import { render, staticRenderFns } from "./EighthPage.vue?vue&type=template&id=16c9318c&scoped=true"
import script from "./EighthPage.vue?vue&type=script&lang=js"
export * from "./EighthPage.vue?vue&type=script&lang=js"
import style0 from "./EighthPage.vue?vue&type=style&index=0&id=16c9318c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c9318c",
  null
  
)

export default component.exports